import React from 'react'

import { Empty } from 'src/components/atoms'

import TableList from '../table-list'

type Props = {
  dataSource?: any
  filterRole?: any
  loading?: any
  pagination?: any
  setFilterRole?: any
  setVisibleModal?: any
  treesSelected?: any
}

export default function HierarchyRoles({
  dataSource,
  filterRole,
  loading,
  pagination,
  setFilterRole,
  setVisibleModal,
  treesSelected
}: Props) {
  if (!treesSelected?.id) {
    return <Empty />
  }

  return (
    <TableList
      dataSource={dataSource}
      filterRole={filterRole}
      loading={loading}
      pagination={pagination}
      setFilterRole={setFilterRole}
      setVisibleModal={setVisibleModal}
      treesSelected={treesSelected}
    />
  )
}
